<template>
    <app-layout>

        <bax-header-banner :user="authenticatedUser" />

        <div class="custom-formulation-notice" v-if="$route.query.customFormulationDelete">
            <div class="container full-page">
                <p>Your custom formulation has been deleted</p>
            </div>
        </div>
        <div class="patient-registration-notice" v-if="$route.query.registrationCancel">
            <div class="container full-page">
                <p v-if="$route.query.registrationCancel ==='nutrition'">Your Home PN patient registration has been cancelled</p>
                <p v-if="$route.query.registrationCancel ==='fluids'">Your Home IVT patient registration has been cancelled</p>
            </div>
        </div>
        <div class="patient-registration-notice" v-if="$route.query.registrationSave">
            <div class="container full-page">
                <p v-if="$route.query.registrationSave ==='nutrition'">Your Home PN patient registration for {{$route.query.name}} has been saved</p>
                <p v-if="$route.query.registrationSave ==='fluids'">Your Home IVT patient registration for {{$route.query.name}} has been saved</p>
            </div>
        </div>
        <div class="patient-registration-notice" v-if="$route.query.registrationDelete">
            <div class="container full-page">
                <p>All draft registrations deleted</p>
            </div>
        </div>

        <main class="home">
            <div class="bax-section">
                <div class="container"  :class="(isTPN() ? 'full-page' : '')">

                    <template v-for="(announcement, i) in authenticatedUser.announcementAlerts">
                        <vue-modal :open="showAnnouncement[i]" v-bind:key="redraw + '_' + i">
                            <div class="bax-modal-content bax-modal-icon-content text-center">
                            <div class="bax-icon bax-remove d-flex align-items-center justify-content-center">
                                <i class="icon-exclamation"></i>
                            </div>
                            <p v-html="announcement"></p>
                            <div class="bax-modal-action-items">
                                <ul class="d-md-flex justify-content-center">
                                <li>
                                    <a href="/#/user/logout" class="bax-btn bax-btn-gray mt-3 mt-md-0">Logout</a>
                                </li>
                                <li>
                                    <a href="#" class="bax-btn bax-btn-orange mt-3 mt-md-0" @click.prevent="closeAnnouncement(i)">Continue</a>
                                </li>
                                </ul>
                            </div>
                            </div>
                        </vue-modal>
                    </template>

                    <template v-for="(announcement, i) in authenticatedUser.announcementNotices">
                        <div class="bax-start-section bax-announcement-section text-center text-md-left d-md-flex align-items-center"  v-bind:key="redraw + '_' + i" v-if="showAnnouncement[i]">
                            <div class="bax-icon-start d-flex align-items-center justify-content-center">
                                <i class="icon-exclamation"></i>
                            </div>
                            <div class="bax-announcement-content">
                                <p v-html="announcement"></p>
                            </div>
                            <a href="javascript:;" class="bax-modal-close" @click="closeAnnouncement(i)"><i class="icon-close"></i></a>
                        </div>
                    </template>

                    <div class="bax-start-section bax-announcement-section bax-ga-permissions text-center text-md-left d-md-flex align-items-center" v-if="showGaPermission">
                        <div class="bax-icon-start d-flex align-items-center justify-content-center">
                            <i class="icon-exclamation"></i>
                        </div>
                        <div class="bax-announcement-content">
                            <p>Consent Google Analytics tracking?</p>
                            <br>
                            <vue-button color="green" @click="GaPremissionAllow">Yes</vue-button>
                            <vue-button color="default" @click="GaPremissionDeny">No</vue-button>
                        </div>
                        <a href="javascript:;" class="bax-modal-close" @click="closeGaPermission"><i class="icon-close"></i></a>
                    </div>

                    <template v-if="activesite === 'compounding'">

                        <template v-if="authenticatedUser.baxterRoles.can_create_edit_orders">

                            <div class="bax-start-section text-center text-md-left d-md-flex align-items-center" >
                                <div class="bax-icon-start d-flex align-items-center justify-content-center">
                                    <img src="@/assets/images/contract@2x.png" alt="Contract">
                                </div>
                                <div class="bax-start-content">
                                    <h3>Start New Order</h3>
                                    <p>{{ authenticatedUser.hospitalName }}</p>
                                </div>
                                <div class="ml-auto">
                                    <router-link :to="{ name: 'createOrder' }" class="bax-btn bax-btn-green-3">Start</router-link>
                                </div>
                            </div>

                        </template>

                        <template v-if="authenticatedUser.baxterRoles.can_create_edit_orders && !process">
                            <div class="bax-start-section bax-importcsv-section text-center text-md-left d-md-flex align-items-center" v-if="csvVisible">
                                <div class="bax-icon-start d-flex align-items-center justify-content-center">
                                    <img src="@/assets/images/file-upload.png" alt="">
                                </div>
                                <div class="bax-start-content">
                                    <h3>Import CSV File</h3>
                                    <p>{{ authenticatedUser.hospitalName }}</p>
                                </div>
                                <div class="ml-auto">
                                    <router-link :to="{ name: 'csvUpload' }" class="bax-btn bax-btn-green-3">Import</router-link>
                                </div>
                            </div>
                        </template>

                        <template v-if="authenticatedUser.baxterRoles.can_create_edit_orders && process">
                            <div class="bax-start-section bax-importcsv-section text-center text-md-left d-md-flex align-items-center" v-if="csvVisible">
                                <div class="bax-icon-start d-flex align-items-center justify-content-center">
                                    <img src="@/assets/images/file-upload.png" alt="">
                                </div>
                                <div v-if="orderStatus === 'progress'" class="bax-start-content">
                                    <h3 class="status-text text-nowrap">CSV Upload Process - In Progress</h3>
                                    <p>{{ authenticatedUser.hospitalName }}</p>
                                </div>
                                <div v-else-if="orderStatus === 'processed'" class="bax-start-content">
                                    <h3 class="status-text text-nowrap">CSV Upload Process - Completed</h3>
                                    <p>{{ authenticatedUser.hospitalName }}</p>
                                </div>
                                <div v-if="orderStatus === 'processed'" class="ml-auto">
                                    <router-link :to="{ name: 'csvUpload' }" class="bax-btn bax-btn-green-3 text-nowrap">Complete Order</router-link>
                                </div>
                            </div>
                        </template>

                        <template v-if="authenticatedUser.baxterRoles.can_view_orders">
                            <div class="bax-order-summary-wrap">
                                <div class="bax-search-bar d-md-flex align-items-md-center">
                                    <h2>Your Orders</h2>
                                    <div class="bax-form-wrapper ml-auto">
                                        <form novalidate @submit.prevent="searchOrder">
                                        <div className="flex flex-col content-end">
                                            <div class="d-flex bax-search-element bax-dark-gray-1">
                                                <div class="bax-form-element">
                                                    <input type="search" v-model="searchKeyword" placeholder="Search (order # or patient name)" v-if="!isTPN()">
                                                    <input type="search" v-model="searchKeyword" placeholder="Search order #" v-if="isTPN()">
                                                </div>
                                                <div class="bax-form-elemnt">
                                                    <button type="submit"><i class="icon-search"></i></button>
                                                </div>
                                            </div>
                                            <div class="cursor-pointer mt-2 text-xs text-right" @click.prevent="searchOrderAdv">Advanced Search</div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                                <div class="bax-order-stats">
                                    <ul class="d-md-flex">
                                        <li>
                                            <label>Recent orders</label>
                                            <span>{{ orderNumberSummary.recentOrdersNumber }}</span>
                                            <a href="#" @click.prevent="goToManageOrder('recent')" class="d-flex align-items-center justify-content-end">View <i class="icon-chevron-right"></i></a>
                                        </li>
                                        <li v-if="!isTPN()">
                                            <label>Orders with On Hold items</label>
                                            <span>{{ orderNumberSummary.onHoldOrdersNumber }}</span>
                                            <a href="#" @click.prevent="goToManageOrder('onHold')" class="d-flex align-items-center justify-content-end">View <i class="icon-chevron-right"></i></a>
                                        </li>
                                        <li>
                                            <label>Draft orders</label>
                                            <span>{{ orderNumberSummary.draftOrdersNumber }}</span>
                                            <a href="#" @click.prevent="goToManageOrder('draft')" class="d-flex align-items-center justify-content-end">View <i class="icon-chevron-right"></i></a>
                                        </li>
                                    </ul>
                                </div>
                            </div>

                            <div class="bax-filter">
                                <bax-order-list :orders="recentOrders" />
                            </div>
                        </template>
                    </template>

                    <template v-if="activesite === 'nutrition'">

                        <div class="d-flex nutrition-actions">

                            <template v-if="authenticatedUser.baxterRoles.can_create_edit_orders">
                                <div class="bax-start-section d-flex tpn-start">
                                    <div class="d-flex top-row">
                                        <div class="bax-icon-start d-flex align-items-center justify-content-center">
                                            <img src="@/assets/images/ico_new_order.svg" alt="Order">
                                        </div>
                                        <div class="bax-start-content">
                                            <h3>Start New Order</h3>
                                            <p>{{ authenticatedUser.hospitalName }}</p>
                                        </div>
                                    </div>
                                    <div class="ml-auto">
                                        <router-link :to="{ name: 'createOrderTPN' }" class="bax-btn bax-btn-blue-brand">Start</router-link>
                                    </div>
                                </div>
                            </template>

                            <template v-if="authenticatedUser.baxterRoles.can_register_home_patients">
                                <div class="bax-start-section d-flex tpn-register">
                                    <div class="d-flex top-row">
                                        <div class="bax-icon-start d-flex align-items-center justify-content-center">
                                            <img src="@/assets/images/ico_patient.svg" alt="Register">
                                        </div>
                                        <div class="bax-start-content">
                                            <h3>Register a Home Patient for PN or IVT</h3>
                                        </div>
                                    </div>
                                    <div class="ml-auto">
                                        <router-link :to="{ name: 'TPNRegisterPatient' }" class="bax-btn bax-btn-bordered-blue-brand">Register</router-link>
                                    </div>
                                </div>
                            </template>

                            <div class="bax-start-section d-flex tpn-contact">
                                <div class="d-flex top-row">
                                    <div class="bax-icon-start d-flex align-items-center justify-content-center">
                                        <img src="@/assets/images/ico_cog.svg" alt="Custom">
                                    </div>
                                    <div class="bax-start-content">
                                        <h3>Create a custom formulation</h3>
                                        <p>{{ authenticatedUser.hospitalName }}</p>
                                    </div>
                                </div>
                                <div class="ml-auto">
                                    <router-link :to="{ name: 'TPNCustomFormulation' }" class="bax-btn bax-btn-bordered-blue-brand">Create formulation</router-link>
                                </div>
                            </div>

                        </div>

                        <template v-if="authenticatedUser.baxterRoles.can_view_orders">
                            <div class="bax-order-summary-wrap nutrition">

                                <div class="tabs-header">
                                    <button :class="nutritionActiveTab === 'orders' ? 'active' : ''" @click.prevent="setNutritionTab('orders')">Orders</button>
                                    <button :class="nutritionActiveTab === 'formulations' ? 'active' : ''" @click.prevent="setNutritionTab('formulations')">Formulations</button>
                                </div>

                                <div class="tabs-body">
                                    <template v-if="nutritionActiveTab === 'orders'">

                                        <div class="bax-search-bar d-md-flex align-items-md-center">
                                            <h2>Your Orders</h2>
                                            <div class="bax-form-wrapper ml-auto">
                                                <form novalidate @submit.prevent="searchOrder">
                                                <div className="flex flex-col content-end">
                                                    <div class="d-flex bax-search-element bax-dark-gray-1">
                                                        <div class="bax-form-element">
                                                            <input type="search" v-model="searchKeyword" placeholder="Search (order # or patient name)" v-if="!isTPN()">
                                                            <input type="search" v-model="searchKeyword" placeholder="Search order #" v-if="isTPN()">
                                                        </div>
                                                        <div class="bax-form-elemnt">
                                                            <button type="submit"><i class="icon-search"></i></button>
                                                        </div>
                                                    </div>
                                                    <div class="cursor-pointer mt-2 text-xs text-right" @click.prevent="searchOrderAdv">Advanced Search</div>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>

                                        <div class="bax-order-stats">
                                            <ul class="d-md-flex">
                                                <li>
                                                    <label>Recent orders</label>
                                                    <span>{{ orderNumberSummary.recentOrdersNumber }}</span>
                                                    <a href="#" @click.prevent="goToManageOrder('recent')" class="d-flex align-items-center justify-content-end">View <i class="icon-chevron-right"></i></a>
                                                </li>
                                                <li v-if="!isTPN()">
                                                    <label>Orders with On Hold items</label>
                                                    <span>{{ orderNumberSummary.onHoldOrdersNumber }}</span>
                                                    <a href="#" @click.prevent="goToManageOrder('onHold')" class="d-flex align-items-center justify-content-end">View <i class="icon-chevron-right"></i></a>
                                                </li>
                                                <li>
                                                    <label>Draft orders</label>
                                                    <span>{{ orderNumberSummary.draftOrdersNumber }}</span>
                                                    <a href="#" @click.prevent="goToManageOrder('draft')" class="d-flex align-items-center justify-content-end">View <i class="icon-chevron-right"></i></a>
                                                </li>
                                            </ul>
                                        </div>

                                        <div class="bax-filter">
                                            <bax-order-list :orders="recentOrders" />
                                        </div>
                                    </template>

                                    <template v-if="nutritionActiveTab === 'formulations'">

                                        <div class="bax-search-bar d-md-flex align-items-md-center">
                                            <h2>Your Formulations</h2>
                                            <div class="bax-form-wrapper ml-auto">
                                                <form novalidate @submit.prevent="searchFormulations">
                                                    <div className="flex flex-col content-end">
                                                        <div class="d-flex bax-search-element bax-dark-gray-1">
                                                            <div class="bax-form-element">
                                                                <input type="search" v-model="searchKeyword" placeholder="Search formulation description">
                                                            </div>
                                                            <div class="bax-form-elemnt">
                                                                <button type="submit"><i class="icon-search"></i></button>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </form>
                                            </div>
                                        </div>

                                        <div class="bax-order-stats">
                                            <ul class="d-md-flex">
                                                <li>
                                                    <label>Recently submitted for review</label>
                                                    <span>{{ formulationNumberSummary.countSubmitted }}</span>
                                                    <a href="#" @click.prevent="goToFormulations('submitted')" class="d-flex align-items-center justify-content-end">View <i class="icon-chevron-right"></i></a>
                                                </li>
                                                <!-- <li>
                                                    <label>Ready to order</label>
                                                    <span>{{ formulationNumberSummary.countReady }}</span>
                                                    <a href="#" @click.prevent="goToFormulations('ready')" class="d-flex align-items-center justify-content-end">View <i class="icon-chevron-right"></i></a>
                                                </li> -->
                                                <li>
                                                    <label>Draft formulations</label>
                                                    <span>{{ formulationNumberSummary.countDraft }}</span>
                                                    <a href="#" @click.prevent="goToFormulations('draft')" class="d-flex align-items-center justify-content-end">View <i class="icon-chevron-right"></i></a>
                                                </li>
                                            </ul>
                                        </div>

                                        <div class="bax-filter">
                                            <BaxFormulationList :formulations="recentFormulations" />
                                        </div>
                                    </template>
                                </div>
                            </div>
                        </template>
                    </template>
                </div>
            </div>
        </main>
    </app-layout>
</template>

<script>
import _ from 'lodash';
import { mapGetters } from 'vuex';
import CsvService from '@/core/api/csv/csv.service3';
import AppLayout from '@/components/layout/AppLayout.vue';
import { scrollPageToTop } from '@/core/helpers';
import OrderService from '@/core/api/order/order.service';
import CustomFormulationService from '@/core/api/tpn/customFormulation.service';
import BaxOrderList from '@/views/Order/BaxOrderList.vue';
import BaxFormulationList from '@/views/Order/BaxFormulationList.vue';
import BaxHeaderBanner from '@/components/layout/BaxHeaderBanner.vue';
import User from '@/core/api/auth/User.class';
import { bootstrap } from 'vue-gtag';
import tpnMixin from '@/mixins/tpnMixin';

// import { getGAid } from '@/utils/env';

export default {
    name: 'Home',
    mixins: [tpnMixin],
    components: {
    AppLayout,
        BaxOrderList,
        BaxFormulationList,
        BaxHeaderBanner,
    },
    data() {
        return {
            csvVisible: false,
            showAnnouncement: {},
            showGaPermission: false,
            searchKeyword: '',
            orderNumberSummary: {
                recentOrdersNumber: 0,
                onHoldOrdersNumber: 0,
                draftOrdersNumber: 0,
            },
            formulationNumberSummary: {
                countSubmitted: 0,
                countReady: 0,
                countDraft: 0,
            },
            recentOrders: [],
            recentFormulations: [],
            redraw: 0,
            activesite: 'compounding',
            nutritionActiveTab: 'orders',
            process: false,
            orderStatus: '',
        };
    },
    watch: {
        $route() {
            this.refreshOrders();
        },
    },
    computed: {
        ...mapGetters(['authenticatedUser']),
    },
    searchOrderAdv() {
      const routeName = this.isTPN() ? 'manageTpnOrders' : 'manageOrders';
      const isAdvanced = true;
      clearInterval(this.interval);
      this.$router.push({
        name: routeName,
        query: { isAdvanced },
      });
    },
    created() {
        this.interval = setInterval(() => this.getPreviousRecords(), 50000);
    },
    mounted() {
        this.refreshOrders();
        this.getPreviousRecords();
    },
    beforeDestroy() {
        clearInterval(this.interval);
    },
    methods: {
        enableGATracking() {
            bootstrap().then(() => {
            });
        },
        setNutritionTab(type) {
            this.nutritionActiveTab = type;
        },
        refreshOrders() {
            this.recentOrders = [];
            this.recentFormulations = [];
            this.orderNumberSummary.recentOrdersNumber = 0;
            this.orderNumberSummary.onHoldOrdersNumber = 0;
            this.orderNumberSummary.draftOrdersNumber = 0;

            scrollPageToTop();

            setTimeout(this.pushAcquireValues, 1000);

            this.csvVisible = (this.authenticatedUser.checkPref('CSV Import'));

            const req = {};
            if (this.isTPN()) {
                req.type = 'TPN';
                OrderService.orderStatusInfo(req).then((res) => {
                    this.orderNumberSummary = res.data;
                    this.orderNumberSummary.recentOrdersNumber = 0;
                    OrderService.tpnOrders().then((res2) => {
                        const { data } = res2;
                        const arr = _.values(data);
                        this.orderNumberSummary.recentOrdersNumber = arr.length;
                        const a = arr.slice(0, 3);
                        this.recentOrders = a;
                    });
                });

                CustomFormulationService.getFormulationsStats().then((res) => {
                    this.formulationNumberSummary = res.data.stats;
                    this.recentFormulations = res.data.recent;
                });
            } else {
                req.type = 'CMP';
                OrderService.orderStatusInfo(req)
                .then((res) => {
                    this.orderNumberSummary = res.data;
                });

                OrderService.orderTypeList()
                .then((res) => {
                    const { data } = res;
                    const arr = _.values(data);
                    const a = arr.slice(0, 3);
                    this.recentOrders = a;
                });
            }

            Object.keys(this.authenticatedUser.announcementNotices).forEach((i) => {
                const cookieName = 'seenAnnouncement' + i;

                if (this.getCookie(cookieName) === '1') {
                this.showAnnouncement[i] = false;
                } else {
                this.showAnnouncement[i] = true;
                }
            });

            Object.keys(this.authenticatedUser.announcementAlerts).forEach((i) => {
                const cookieName = 'seenAnnouncement' + i;

                if (this.getCookie(cookieName) === '1') {
                this.showAnnouncement[i] = false;
                } else {
                this.showAnnouncement[i] = true;
                }
            });

            if (this.authenticatedUser.gaPermission == null) {
                this.showGaPermission = true;
            }

            if (this.authenticatedUser.gaPermission === 'allow') {
                this.enableGATracking();
            }
            this.$root.$on('activateSite', (site) => {
                if (site) {
                this.activesite = site;
                }
            });
        },
        gotoManageSingleOrder(order) {
            clearInterval(this.interval);
            this.$router.push({
                name: 'manageSingleOrder',
                params: {
                    orderId: order.groupOrderID,
                },
                query: {
                    from: this.$route.name,
                },
            });
        },
        searchOrderAdv() {
            const routeName = this.isTPN() ? 'manageTpnOrders' : 'manageOrders';
            const isAdvanced = true;
            clearInterval(this.interval);
            this.$router.push({
                name: routeName,
                query: { isAdvanced }
            });
        },
        searchOrder() {
            if (this.searchKeyword !== '') {
                clearInterval(this.interval);
                this.$router.push({
                    name: this.isTPN() ? 'manageTpnOrders' : 'manageOrders',
                    query: {
                        q: this.searchKeyword,
                    },
                });
            } else {
                clearInterval(this.interval);
                this.$router.push({
                    name: this.isTPN() ? 'manageTpnOrders' : 'manageOrders',
                });
            }
        },
        searchFormulations() {
            if (this.searchKeyword !== '') {
                clearInterval(this.interval);
                this.$router.push({
                    name: 'TPNCustomFormulation',
                    query: {
                        q: this.searchKeyword,
                    },
                });
            } else {
                clearInterval(this.interval);
                this.$router.push({
                    name: 'TPNCustomFormulation',
                });
            }
        },
        goToFormulations(type) {
            clearInterval(this.interval);
            this.$router.push({
                name: 'TPNCustomFormulation',
                query: {
                    status: type,
                },
            });
        },
        goToManageOrder(type) {
            if (this.isTPN()) {
                clearInterval(this.interval);
                this.$router.push({
                name: 'manageTpnOrders',
                query: {
                    order: type,
                },
                });
            } else {
                clearInterval(this.interval);
                this.$router.push({
                name: 'manageOrders',
                query: {
                    order: type,
                },
                });
            }
        },
        closeAnnouncement(i) {
            // this.showAnnouncement.$set(i, false);
            this.$set(this.showAnnouncement, i, false);
            const cookieName = 'seenAnnouncement' + i;
            document.cookie = cookieName + '=1';
            this.redraw += 1;
        },
        closeGaPermission() {
            this.showGaPermission = false;
        },
        GaPremissionAllow() {
            User.updateGaPermission('allow').then(() => {
                window.location.reload();
            });
        },
        GaPremissionDeny() {
            User.updateGaPermission('deny').then(() => {
                window.location.reload();
            });
        },

        getCookie(cname) {
            const name = cname + '=';
            const decodedCookie = decodeURIComponent(document.cookie);
            const ca = decodedCookie.split(';');
            for (let i = 0; i < ca.length; i += 1) {
                let c = ca[i];
                while (c.charAt(0) === ' ') {
                    c = c.substring(1);
                }
                if (c.indexOf(name) === 0) {
                    return c.substring(name.length, c.length);
                }
            }
            return '';
        },
        pushAcquireValues() {
            // eslint-disable-next-line no-console
            window.acquire = window.acquire || [];
            let phoneNumber = this.authenticatedUser.mobileNumber;
            if (!phoneNumber) {
                phoneNumber = this.authenticatedUser.contactNumber;
            }

            window.acquire.push({
                fields: {
                    contact: {
                        name: this.authenticatedUser.firstName + ' ' + this.authenticatedUser.lastName,
                        email: this.authenticatedUser.email,
                        phone: phoneNumber,
                        // calling_code: '00',
                        source: 'Baxter BOLT',
                        // city: 'test2',
                        state: this.authenticatedUser.hospitalStateCode,
                        contact_state: this.authenticatedUser.hospitalStateCode,
                        countryid: '298', // AU = 298, NZ = 454, UK = 362, USA = 517, IT = 394
                        // address: 'test',
                        // location: 'test',
                        // contact_country_flag: 'test',
                        institution: this.authenticatedUser.hospitalName,
                    },
                },
                lang: 'AU', // LANGUAGE CODE
            });
        },
        getPreviousRecords() {
        CsvService.fetchProcessedRows()
            .then((res) => {
              this.uploadCode = res.data.uploadCode;
              this.orderStatus = res.data.status;
              if ((this.orderStatus === 'progress' || this.orderStatus === 'processed') && this.uploadCode) {
                this.process = true;
              }
        });
        },

    },
};
</script>

<style lang="scss" scoped>

.status-text {
    color: red;
}
</style>
